import { Injectable } from '@angular/core';
import { ServiceHandlerService } from '../service-handler.service';
import { Observable, Subject } from 'rxjs';
import { buffer, debounceTime } from 'rxjs/operators';
import {
  MonetateEventType,
  MonetateRecAnalyticsRequest,
} from '@usf/product-types';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MonetateAnalyticsService {
  constructor(private serviceHandler: ServiceHandlerService) {}

  getSeenProductObserver(
    seenProductSubject$: Subject<string>,
    seenProductSet: Set<string>,
  ): IntersectionObserver {
    return new IntersectionObserver(
      (entries, observer) => {
        this.sendSeenProductToSubject(
          entries,
          observer,
          seenProductSubject$,
          seenProductSet,
        );
      },
      {
        root: null,
        threshold: 0.75,
      },
    );
  }

  getSeenProductObservable(
    seenProductSubject$: Subject<string>,
  ): Observable<string[]> {
    return seenProductSubject$.pipe(
      buffer(seenProductSubject$.pipe(debounceTime(1000))),
    );
  }

  postImpressionsToMonetate(recTokens: string[]): Observable<number> {
    const body: MonetateRecAnalyticsRequest = {
      eventType: MonetateEventType.RecImpressions,
      recTokens,
    };
    return this.serviceHandler.post(environment.monetateAnalyticsApiUrl, body);
  }

  postClickToMonetate(recToken: string): Observable<number> {
    const body: MonetateRecAnalyticsRequest = {
      eventType: MonetateEventType.RecClicks,
      recTokens: [recToken],
    };
    return this.serviceHandler.post(environment.monetateAnalyticsApiUrl, body);
  }

  logProductAsSeen(
    seenProductSubject$: Subject<string>,
    seenProductSet: Set<string>,
    recToken: string,
  ) {
    if (!seenProductSet.has(recToken)) {
      seenProductSubject$.next(recToken);
      seenProductSet.add(recToken);
    }
  }

  private sendSeenProductToSubject(
    entries: IntersectionObserverEntry[],
    observer: IntersectionObserver,
    seenProductSubject$: Subject<string>,
    seenProductSet: Set<string>,
  ): void {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const recToken = entry.target.id;

        if (!seenProductSet.has(recToken)) {
          seenProductSubject$.next(recToken);
          seenProductSet.add(recToken);
          observer.unobserve(entry.target);
        }
      }
    });
  }
}
